import { createContext, useContext, useLayoutEffect } from 'react';

export type ApplicationLayoutBottomBarConfig = {
    ariaLabel: string;
    isRefreshing: boolean;
    onRefresh: () => void;
    testId?: string;
    trackingKey?: string;
};

type ApplicationLayoutBottomBarContextType = {
    setBottomBar: (bottomBar: ApplicationLayoutBottomBarConfig | null) => void;
};

const noop = () => undefined;

export const ApplicationLayoutBottomBarContext = createContext<ApplicationLayoutBottomBarContextType>({
    setBottomBar: noop,
});

export const useApplicationLayoutBottomBar = (bottomBar: ApplicationLayoutBottomBarConfig | null) => {
    const { setBottomBar } = useContext(ApplicationLayoutBottomBarContext);

    useLayoutEffect(() => {
        setBottomBar(bottomBar);
    }, [
        bottomBar?.ariaLabel,
        bottomBar?.isRefreshing,
        bottomBar?.onRefresh,
        bottomBar?.testId,
        bottomBar?.trackingKey,
        setBottomBar,
    ]);

    useLayoutEffect(
        () => () => {
            setBottomBar(null);
        },
        [setBottomBar]
    );
};
